import React, { useEffect, useContext } from 'react'
import * as classes from './Preloader.module.scss'
import LoaderAnimation from './LoaderAnimation'
import anime from 'animejs'
import { FormContext } from '../../../context'

const HOLD_DURATION = 850
const FADE_DURATION = 350

function Preloader() {
    const { setAnimationStart, setIsVisibilityPreloader } = useContext(FormContext)

    useEffect(() => {
        const timeout = setTimeout(() => {
            setAnimationStart(true)

            const wrap = document.querySelector(`.${classes.Wrap}`)

            if (wrap) {
                anime({
                    targets: wrap,
                    duration: FADE_DURATION,
                    delay: 0,
                    easing: 'cubicBezier(.25, .1, .25, 1)',
                    opacity: [1, 0]
                }).finished.then(() => setIsVisibilityPreloader(false))
            } else {
                setIsVisibilityPreloader(false)
            }
        }, HOLD_DURATION)

        return () => clearTimeout(timeout)
    }, [])

    return (
        <div className={classes.Preloader}>
            <div className={classes.Wrap}>
                <div className={classes.Logo}>
                    <LoaderAnimation />
                </div>
            </div>
        </div>
    )
}

export default Preloader
